import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const CustomSearchBar = ({
  rows,
  setFilteredRows,
  setIsSearch,
  searchVal,
  setSearchVal,
  setpagination,
  deferFilterToParent = false
}) => {
  const handleChange = async (e) => {
    // Reset page to first page when search is performed
    setIsSearch(e.target.value.length);
    setSearchVal(e.target.value);

    if (setpagination) {
      setpagination(e.target.value); // Using if statement to ensure no-unused-expression rule is met
    }

    if (deferFilterToParent) {
      return;
    }

    await setFilteredRows(
      e.target.value.length > 0
        ? rows.filter((row) =>
            Object.values(row).some(
              (value) =>
                typeof value === 'string' &&
                value.toLowerCase().includes(e.target.value.toLowerCase())
            )
          )
        : rows
    );
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      value={searchVal}
      placeholder="Search..."
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        )
      }}
    />
  );
};

export default CustomSearchBar;
